/**
 * Get a string of classes from a class and an array of modifiers
 * @param {string} className
 * @param {array} modifiers
 * @returns {string}
 */
export const getClassNames = (className, modifiers = []) =>
  [className, ...modifiers.filter(Boolean).map((modifier) => `${className}--${modifier}`)].filter(Boolean).join(' ');

/**
 * Get an array of valid classes from a string (i.e. it is useful for getting an array of modifiers)
 * @param {string} className
 * @returns {array}
 */
export const splitClassName = (className) => className.split(' ').filter(Boolean);

/**
 * CSS class manipulation tool
 *
 * Usage:
 *
 * className({
 *   'css-class-name-1': true,      // this key is added to final className
 *   'css-class-name-2': false,     // this key is NOT added
 *   'css-class-name-3': myVariable // this key is added if myVariable is truthy
 * })
 *
 * @returns {string}
 */

export const className = (config) => {
  const classList = [];
  Object.entries(config).forEach(([cN, condition]) => {
    if (condition) {
      classList.push(cN);
    }
  });
  return classList.join(' ');
};
